export default __webpack_public_path__ + "static/media/addepar.4458c671.png";